import { Translations } from './en';

export const da: Translations = {
    welcome: 'Velkommen',
    welcomeMessage: 'Log ind på plandag for at se din tidsplan.',
    login: 'Log ind',
    register: 'Registrer',
    forgotPassword: 'Glemt adgangskode',
    resetPassword: 'Nulstil adgangskode',
    email: 'E-mail',
    password: 'Adgangskode',
    confirmPassword: 'Bekræft adgangskode',
    rememberMe: 'Husk mig',
    continue: 'Fortsæt',
    selectOrganization: 'Vælg organisation',
    organizationEmail: 'E-mailen <span class="font-semibold text-[#00165A] bg-slate-100 px-1.5 py-0.5 rounded">{{email}}</span> er tilknyttet flere organisationer.',
    organizationEmailMessage: 'Vælg det arbejdsområde, du vil have adgang til.',
    organization: 'Organisation',
    chooseOrganization: 'Vælg en organisation',
    backToLogin: 'Tilbage til login',
    theEmail: 'E-mailen',
    isAssociatedWithMultipleOrganizations: 'er tilknyttet flere organisationer.',
    theSimplestWayToManage: 'Den enkleste måde at styre',
    yourWorkforce: 'din arbejdsstyrke',
    loginRightPanelMessage: 'Giv dit team et administrationsværktøj bygget til hastighed, enkelhed og kontrol. Fra budgetopfølgning til automatisering af arbejdsgange fungerer alt sammen, så du kan fokusere på vækst, ikke administration.',
    personalDetails: 'Personlige oplysninger',
    businessDetails: 'Virksomhedsoplysninger',
    createYourAccount: 'Opret din konto',
    name: 'Navn',
    willBeUsedAsUsernameForLogin: '(bruges som brugernavn ved login)',
    enterYourName: 'Indtast dit navn',
    enterYourEmail: 'Indtast din e-mail',
    select: '--Vælg--',
    phoneNumber: 'Telefonnummer',
    enterYourMobileNumber: 'Indtast dit mobilnummer',
    country: 'Land',
    atLeastOneLowercase: 'Mindst ét lille bogstav',
    atLeastOneUppercase: 'Mindst ét stort bogstav',
    atLeastOneNumeric: 'Mindst ét tal',
    minimum8Characters: 'Mindst 8 tegn',
    agreeAndContinue: 'Acceptér og fortsæt',
    personalDetailsMessage: 'Dette sprog bliver standard for systembeskeder og nye brugere. Du kan altid ændre det i brugerindstillingerne senere.',
    agreeAndContinueMessage: 'Ved at klikke på acceptér og fortsæt bekræfter du, at du har læst og accepteret vores databehandleraftale, privatlivspolitik, prøvevilkår og generelle vilkår og giver samtykke til at modtage salgskommunikation via telefon, e-mail eller Wiser-appen i din 30-dages prøveperiode. Du kan afmelde dig når som helst.',
    tellUsAboutYourBusiness: 'Fortæl os om din virksomhed',
    withABusinessDetails: 'Med et par virksomhedsoplysninger tilpasser vi Wiser til din virksomhed og dit domæne',
    businessName: 'Virksomhedsnavn',
    enterYourBusinessName: 'Indtast dit virksomhedsnavn',
    businessLocation: 'Virksomhedens placering',
    businessType: 'Virksomhedstype',
    language: 'Sprog',
    timezone: 'Tidszone',
    howManyEmployeesDoYouHave: 'Hvor mange medarbejdere har du?',
    previous: 'Forrige',
    createAccount: 'Opret konto',
    startYour30DaysTrial: 'Start din prøveperiode på 30 dage',
    noCreditCardRequired: 'Intet kreditkort kræves!',
    exploreWiserFeaturesAtNoCost: 'Udforsk Wiser-funktioner uden omkostninger!',
    forgotYourPassword: 'Glemt din adgangskode?',
    enterYourEmailAddressAndWeWillSendYou: 'Indtast din e-mailadresse, så sender vi dig',
    instructionsToResetYourPassword: 'instruktioner til at nulstille din adgangskode.',
    youHaveReachedTheEmailRequestLimit: 'Du har nået grænsen for e-mailanmodninger. Tjek din indbakke, eller prøv igen om 15 minutter.',
    checkYourEmail: 'Tjek din e-mail',
    pleaseCheckTheEmailAddress: 'Tjek venligst e-mailadressen',
    forInstructionsToResetYourPassword: 'for instruktioner til at nulstille din adgangskode.',
    aNewEmailHasBeenSentToYourInbox: 'En ny e-mail er sendt til din indbakke.',
    resendEmail: 'Send e-mail igen',
    edit: 'Rediger',
    thisFieldIsRequired: 'Dette felt er påkrævet',
    invalidEmailAddress: 'Ugyldig e-mailadresse',
    pleaseEnterAValidEmailAddress: 'Indtast en gyldig e-mailadresse',
    invalidPassword: 'Ugyldig adgangskode',
    minimumLengthIs: 'Minimumslængde er {{length}}',
    maximumLengthIs: 'Maksimumslængde er {{length}}',
    passwordsDoNotMatch: 'Adgangskoderne stemmer ikke overens',
    invalidField: 'Ugyldigt felt',
};